import { QUERY_KEYS } from "@src/query";
import { useQuery } from "@tanstack/react-query";
import { getStatistics } from "./api";
import { Analytics } from "common/dist/types/apiTypes";

export const useQueryStatistics = () =>
    useQuery<Analytics[]>({
      queryKey: QUERY_KEYS.statistics(),
      queryFn: () => getStatistics(),
    });
  